import { render, staticRenderFns } from "./AppInstaller.vue?vue&type=template&id=70c4de3f&"
import script from "./AppInstaller.vue?vue&type=script&lang=js&"
export * from "./AppInstaller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c4de3f')) {
      api.createRecord('70c4de3f', component.options)
    } else {
      api.reload('70c4de3f', component.options)
    }
    module.hot.accept("./AppInstaller.vue?vue&type=template&id=70c4de3f&", function () {
      api.rerender('70c4de3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/common/AppInstaller.vue"
export default component.exports